import Loadable from '../../components/loadable';

const DebtorsReport = Loadable({
  loader: () => import('../../pages/reports/debtors_report'),
  type: 'block',
});

angular.module('gym').value('DebtorsReport', DebtorsReport);

const DebtorsReportFiltersModal = Loadable({
  loader: () => import('../../pages/reports/debtors_report/debtors_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('DebtorsReportFiltersModal', DebtorsReportFiltersModal);

const RemoveFromDebtorsReportDrawer = Loadable({
  loader: () => import('../../pages/reports/debtors_report/remove_from_debtors_report_drawer'),
  type: 'drawer',
});

angular.module('gym').value('RemoveFromDebtorsReportDrawer', RemoveFromDebtorsReportDrawer);

const DebtorReportFailedPaymentsDrawer = Loadable({
  loader: () => import('../../pages/reports/debtors_report/debtor_report_failed_payments_drawer'),
  type: 'drawer',
});

angular.module('gym').value('DebtorReportFailedPaymentsDrawer', DebtorReportFailedPaymentsDrawer);
